import httpService from '@/modules/common/services/httpService';
import { RESOURCE_TYPES_PAGE_SIZE, RESOURCES_PAGE_SIZE } from '@/modules/resources/constants/resourcesConstants';

const gatewayService = httpService.create(window.pov_config.VUE_APP_API_URL_GATEWAY);

const resourceTypesRoute = 'v3/scheduling/resource_types';
const resourcesRoute = 'v3/scheduling/resources';

const DEFAULT_PAGE_INDEX = 1;

const fetchResourceTypes = (pageIndex = DEFAULT_PAGE_INDEX, pageSize = RESOURCE_TYPES_PAGE_SIZE, sort = 'created_at:desc') => gatewayService.get(resourceTypesRoute, {
    page: pageIndex,
    per_page: pageSize,
    sort,
  }).then((res) => res.data?.data?.resource_types);

const getResourceType = (uid) => gatewayService.get(`${resourceTypesRoute}/${uid}`).then((res) => res.data?.data);

const createResourceType = (params) => gatewayService.post(resourceTypesRoute, params).then((res) => res.data);

const updateResourceType = (uid, resourceType) => gatewayService.put(`${resourceTypesRoute}/${uid}`, resourceType).then((res) => res.data?.data);

const deleteResourceType = (uid) => gatewayService.remove(`${resourceTypesRoute}/${uid}`).then((res) => res.data);

const fetchResources = (pageIndex = DEFAULT_PAGE_INDEX, pageSize = RESOURCES_PAGE_SIZE, filter = {}) => gatewayService.get(resourcesRoute, {
    page: pageIndex,
    per_page: pageSize,
    sort: 'created_at:asc',
    ...filter,
  }).then((res) => res.data?.data?.resources);

const getResource = (uid) => gatewayService.get(`${resourcesRoute}/${uid}`).then((res) => res.data?.data);

const createResource = (params) => gatewayService.post(resourcesRoute, params).then((res) => res.data?.data);

const updateResource = (uid, resource) => gatewayService.put(`${resourcesRoute}/${uid}`, resource).then((res) => res.data?.data);

const deleteResource = (uid) => gatewayService.remove(`${resourcesRoute}/${uid}`).then((res) => res.data);

const bulkCreateResources = (resources) => gatewayService.post(`${resourcesRoute}/bulk`, resources).then((res) => res.data?.data);

export default {
  fetchResourceTypes,
  getResourceType,
  createResourceType,
  updateResourceType,
  deleteResourceType,

  fetchResources,
  getResource,
  createResource,
  updateResource,
  deleteResource,
  bulkCreateResources,
};
